<template>
  <v-expand-transition>
    <div v-if="show" class="d-flex justify-center">
      <v-progress-circular
        color="primary"
        v-if="isLoading"
        indeterminate
        :size="size"
        v-bind="$attrs"
      ></v-progress-circular>
      <v-fade-transition>
        <h4 v-if="isEmpty" class="h2 adaptive" :class="emptyColorClass">
          {{ emptyText }}
        </h4>
      </v-fade-transition>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  name: "LoaderElement",
  props: {
    show: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: true },
    isEmpty: { type: Boolean, default: false },
    emptyText: { type: String, default: "Не найдено!" },
    emptyColorClass: { type: String, default: "color-dark" },
    size: { type: Number, default: 100 },
  },
};
</script>

<style scoped></style>
